import { SentryWrapper as Sentry } from '../sentry'
import { bridge } from '../webview/bridge'
import { isValidLurkerEvent } from '../webview/validateLurkerEvent'
import { sendToDataLayer } from '../dataLayer'

const sendCustomTracking = (trackingCallback, payload) => {
  Sentry.addBreadcrumb('lurker', payload)

  /* eslint-disable */
  try {
    if (bridge?.isWebView?.() && typeof bridge.sendToLurker === 'function') {
      const { event_type, object_name, object_detail, data, params, ...rest } = payload
      const finalEvent = {
        event_type,
        object_name,
        object_detail,
        data: data && typeof data === 'object' ? data : {},
        params: params && typeof params === 'object' ? params : { ...(!params && rest) },
      }
      if (isValidLurkerEvent(finalEvent)) {
        bridge.sendToLurker(finalEvent)
        return
      }
    }

    if (trackingCallback) {
      trackingCallback(payload)
    } else {
      console.log('LURKER EVENT: ', payload)
    }

    if (payload?.event_type === 'page_view') {
      try {
        sendToDataLayer(payload.object_name || 'unknown_page', payload.event_type, {
          object_detail: payload.object_detail,
          ...(payload.public_account_id && { public_account_id: payload.public_account_id }),
        })
      } catch (e) {
        console.warn('sendToDataLayer failed:', e)
      }
    }
  } catch (error) {
    console.error(`Error on send Lurker event: ${error}`)
  }
  /* eslint-enable */
}

const lurkerSend = payload => {
  sendCustomTracking(window?.Lurker?.send, payload)
}

/**
 * Sends lurker event payload using browser beacon api. This is useful for redirects
 * @param {*} payload
 */
export const lurkerSendBeacon = payload => {
  sendCustomTracking(window?.Lurker?.sendBeacon, payload)
}

export default lurkerSend
